import { connect } from "react-redux";
import { MultiSelect as Component } from "../MultiSelect";
import { mscqSubmit } from "@learningblocks/exp-redux";
import { mscqSelectOption } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    selectOption: (params) => {
      dispatch(mscqSelectOption(params));
    },
    submitAnswer: (id) => {
      dispatch(mscqSubmit(id));
    },
  };
}
export const MultiSelectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
